<div class="streaming-table-container">
	<div class="table-header">
		<span class="table-title">Uploaded Streaming Data</span>
		<div class="table-header-right">
			<div class="search-container">
				<i class="bi bi-search search-icon"></i>
				<input
					type="text"
					class="search-input"
					placeholder="Search by team, car #, device #..."
					[value]="searchQuery()"
					(input)="onSearchChange($any($event.target).value)"
				/>
				@if (searchQuery()) {
					<button class="search-clear" (click)="clearSearch()" title="Clear search">
						<i class="bi bi-x-lg"></i>
					</button>
				}
			</div>
			<span class="table-count">{{ filteredRows().length }} {{ filteredRows().length === 1 ? 'entry' : 'entries' }}</span>
		</div>
	</div>
	<div class="table-scroll">
		<table class="streaming-table">
			<thead>
				<tr>
					<th>ID</th>
					<th>Team Name</th>
					<th>Car #</th>
					<th>Device #</th>
					<th>RTMP URL</th>
					<th>Stream Key</th>
					<th>Video ID</th>
					<th>HLS Playback URL</th>
					<!-- <th class="text-center">Live</th> -->
				</tr>
			</thead>
			<tbody>
				@for (row of filteredRows(); track row.id) {
					<tr>
						<td class="cell-id">{{ row.id }}</td>
						<td class="cell-text">{{ row.teamName }}</td>
						<td class="cell-number">{{ row.carNumber }}</td>
						<td class="cell-number">{{ row.carDeviceNumber }}</td>
						<td class="cell-url">{{ row.rtmpUrl }}</td>
						<td class="cell-key">{{ row.streamKey }}</td>
						<td class="cell-id">{{ row.videoId }}</td>
						<td class="cell-url">{{ row.hlsPlaybackUrl }}</td>
						<!-- <td class="cell-live text-center">
							@if (row.isLive) {
								<span class="badge-live">Live</span>
							} @else {
								<span class="badge-offline">Offline</span>
							}
						</td> -->
					</tr>
				}
			</tbody>
		</table>
	</div>
</div>
